/* global angular */

var ngModule = angular.module('trends');

var ENTER_KEY = 13;
var SPACE_KEY = 32;
var ARROW_LEFT = 37;
var ARROW_RIGHT = 39;
var ARROW_UP = 38;
var ARROW_DOWN = 40;

ngModule.service('Input', [
    function () {
        /* Add a callback to a jQuery selector. The callback is called on click,
           focus + enter or focus + space. */
        this.addAccessibleClickHandler = function (el, cb, focusable) {
            var handler = function (ev) {
                if (ev.type === 'keydown') {
                    if (ev.which !== ENTER_KEY && ev.which !== SPACE_KEY) {
                        return;
                    }

                    if (focusable) {
                        focusable.focus(); // Maintain focus when using keyboard
                    }
                }

                cb();
            };

            el.on('click', handler);
            el.on('keydown', handler);
        };

        this.addArrowMovementHandler = function (el, cb) {
            var handler = function (ev) {
                var dx = 0;
                var dy = 0;

                if (ev.which === ARROW_LEFT) { dx -= 1; }
                else if (ev.which === ARROW_RIGHT) { dx += 1; }
                else if (ev.which === ARROW_UP) { dy -= 1; }
                else if (ev.which === ARROW_DOWN) { dy += 1; }

                // Cancel any default browser action if the callback indicated a success
                if (cb(dx, dy)) {
                    ev.stopPropagation();
                }
            };

            el.on('keydown', handler);
        };
    }]);
